exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2A3EkH1V_UyDTP{display:flex}._3Yj9q2I4BGFx4r ._1uWLDFWlmhvDog{width:0;height:18px;opacity:0;transition-duration:.15s;transition-property:opacity,width,margin}._3Yj9q2I4BGFx4r:hover ._1uWLDFWlmhvDog{opacity:.75;width:18px;margin-right:6px}._32YjsxnLz_UuuS{background-color:#61bd4f;border-radius:20px;color:#fff;font-size:12px;font-weight:400;line-height:20px;padding:2px 10px;text-align:center}", ""]);

// exports
exports.locals = {
	"sectionHeaderWrapper": "_2A3EkH1V_UyDTP",
	"externalLink": "_3Yj9q2I4BGFx4r",
	"externalIcon": "_1uWLDFWlmhvDog",
	"navigationItemNewLozenge": "_32YjsxnLz_UuuS"
};